export const STOCK_RETURN_TRUNCATED_NOTICE_CLASS = (
  'mt-2 px-1 pb-3 text-xs text-amber-700 border-b border-slate-200'
);
